module.exports = __webpack_public_path__ + "img/appoint.e59539a4.png";